import EditSliderModal from "./editSliderModal";

export default EditSliderModal;
